import GlobalNav from 'components/global-nav'
import { OutOfAreaBanner, InputAddressBanner } from 'components/banners'

const Header = (props) => {
  function renderBanner() {
    const { activeNavItem, currentUser, currentUserCountry } = props

    const shouldShowOutOfAreaBanner =
      currentUserCountry !== null && currentUserCountry !== 'United States'
    const shouldShowInputAddressBanner =
      currentUser && currentUserCountry === null

    if (activeNavItem === 'Store') {
      if (shouldShowOutOfAreaBanner) {
        return (
          <OutOfAreaBanner
            country={currentUserCountry}
            showBabyListButton={currentUser && !currentUser.addedBabyListButton}
          />
        )
      }

      if (shouldShowInputAddressBanner) {
        return <InputAddressBanner />
      }
    }

    return null
  }

  return (
    <>
      {renderBanner()}
      <GlobalNav {...props} />
    </>
  )
}

export default Header
